import React, { useContext, useState, useEffect } from 'react'
import { LanguageContext } from '../Language/LanguageContext'
import { Link } from 'react-router-dom'
import { Row, Col, Button } from 'react-bootstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowLeft, faClock, faWrench, faCheckCircle } from '@fortawesome/free-solid-svg-icons'
import { listServiceStatus } from '../Network/Repair'
import { Loading, HeaderTitle } from '../Library'
import dayjs from 'dayjs'
import "./ServiceStatus.css"

function ServiceStatus() {
    const langCx = useContext(LanguageContext)
    const lang = langCx.lang.service

    const [page, setPage] = useState(1)
    const size = 12
    const [isLoading, setLoading] = useState(false)
    const [serviceList, setServiceItem] = useState([])
    const [lastLength, setLastLength] = useState(0)

    const fetchServiceList = (page, size, loadnew) =>{
        setLoading(true)
        listServiceStatus(page, size,
            (data)=>{
                console.log(data.length)
                if(loadnew){
                    setServiceItem(data)
                    setLastLength(data.length)
                }else{
                    data.map((item)=>{
                        setServiceItem(oldData => [...oldData, item])
                    })
                    setLastLength(data.length)
                }
                setLoading(false)
            },
            (error)=>{
                setLoading(false)
            })
    }

    const loadMore = () =>{
        setPage(page + 1)
        fetchServiceList(page + 1, size, false)
    }

    const onScroll = (event) =>{
        const target = event.target
        if(target.scrollHeight - target.scrollTop === target.clientHeight){
            if(lastLength >= size){
                loadMore()
                console.log("Bottom")
            }
        }
    }

    useEffect(()=>{
        fetchServiceList(page, size, true)
    },[])

    return (
        <div id="service-status">
            { isLoading ? <Loading/>: null }
            <HeaderTitle title={lang.repair_status} isShowBack backTo="/"/>
            <div className="status-container" onScroll={onScroll}>
                <Row>
                { serviceList.map((item, key) =>
                    <Col key={key} md={6} xl={4}>
                        <ServiceItem
                        title={item.description}
                        datetime={item.updatedDate}
                        ticketNumber={item.ticketNumber}
                        status={item.status}
                        />
                    </Col>
                )}
                </Row>
                { lastLength >= size ?
                <div style={{ textAlign: 'center' }}>
                    <Button
                    onClick={()=>loadMore()}
                    >
                        {lang.load_more}
                    </Button>
                </div>
                : null
                }
                { serviceList.length === 0 ?
                <div style={{ textAlign: 'center' }}>
                    {lang.no_status}
                </div>
                : null
                }
            </div>
        </div>
    )
}

function ServiceItem({ title, datetime, status, ticketNumber }){
    const langCx = useContext(LanguageContext)
    const lang = langCx.lang.service
    const langRepair = langCx.lang.repair_service
    
    var isWaiting = false
    var waitingDate = null
    var isInprogress = false
    var inprogressDate = null
    var isComplete = false
    var completeDate = null
    
    status.map((s)=>{
        if(s.status === "WAITING"){
            isWaiting = true
            waitingDate = s.createdDate
        }else if(s.status === "IN_PROGRESS"){
            isInprogress = true
            inprogressDate = s.createdDate
        }else if(s.status === "COMPLETE"){
            isComplete = true
            completeDate = s.createdDate
        }
    })

    const StatusItem = ({ title, date, icon, isActive }) =>{
        return(
            <div className="status-detail"
            style={{
                color: isActive ? 'orange': 'lightgray'
            }}
            >
                <FontAwesomeIcon icon={icon} className="icon"/>
                <div className="text-group">
                    <div className="status-title">{title}</div>
                    { isActive ?
                    <div className="status-desc">{dayjs(date).format("DD MMM YYYY H:mm")}</div>
                    : null
                    }
                </div>
            </div>
        )
    }
    
    return(
        <div className="service-item">
            <div className="title">{title}</div>
            <div className="desc">{lang.datetime} : {dayjs(datetime).format("D MMM YYYY H:mm")}</div>
            <div className="desc">{lang.ticket_number} : {ticketNumber}</div>
            <div className="status">
                <StatusItem 
                title={langRepair.waiting} 
                icon={faClock}
                date={waitingDate}
                isActive={isWaiting}/>
                <StatusItem 
                title={langRepair.in_progress} 
                icon={faWrench}
                date={inprogressDate}
                isActive={isInprogress}/>
                <StatusItem 
                title={langRepair.complete} 
                icon={faCheckCircle}
                date={completeDate}
                isActive={isComplete}/>
            </div>
        </div>
    )
}

export default ServiceStatus
